export default __webpack_public_path__ + "static/media/jumpingMb.d017110e.png";